import React from "react";
import { observer } from "mobx-react";
import { WorkAuthorPublisherUpdateStore } from "../../store";
import { WorkAuthorPublisherUpdateForm } from "./WorkAuthorPublisherUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type WorkAuthorPublisherUpdateProps = {
  workAuthorPublisherUpdateStore: WorkAuthorPublisherUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const WorkAuthorPublisherUpdate: React.FC<WorkAuthorPublisherUpdateProps> =
  observer(
    ({
      workAuthorPublisherUpdateStore,
      showToolbox = true,
      showSaveFooter,
    }) => {
      return (
        <>
          <SavingOverlay open={workAuthorPublisherUpdateStore.isSaving} />
          <WorkAuthorPublisherUpdateForm
            workAuthorPublisherUpdateStore={workAuthorPublisherUpdateStore}
            publisherError={
              workAuthorPublisherUpdateStore.errors.publisher?.message
            }
            onPublisherChange={(value) => {
              workAuthorPublisherUpdateStore.setPublisherValue(value);
            }}
            publisherSelectedValue={
              workAuthorPublisherUpdateStore.entityValues.showPublisher
            }
            onPublisherSelected={(value) => {
              workAuthorPublisherUpdateStore.setSelectedPublisher(value);
            }}
            publisherOptions={workAuthorPublisherUpdateStore.getPublisherOptions()}
            percentageError={
              workAuthorPublisherUpdateStore.errors.percentage?.message
            }
            onPercentageChange={(value: number) => {
              workAuthorPublisherUpdateStore.setPercentageValue(value);
            }}
            percentage={workAuthorPublisherUpdateStore.entityValues.percentage}
            durationInYearsError={
              workAuthorPublisherUpdateStore.errors.durationInYears?.message
            }
            onDurationInYearsChange={(value: number | undefined) => {
              workAuthorPublisherUpdateStore.setDurationInYearsValue(value);
            }}
            durationInYears={
              workAuthorPublisherUpdateStore.entityValues.durationInYears
            }
            autoRenewalYearsError={
              workAuthorPublisherUpdateStore.errors.autoRenewalYears?.message
            }
            onAutoRenewalYearsChange={(value: number | undefined) => {
              workAuthorPublisherUpdateStore.setAutoRenewalYearsValue(value);
            }}
            autoRenewalYears={
              workAuthorPublisherUpdateStore.entityValues.autoRenewalYears
            }
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={workAuthorPublisherUpdateStore.saveDisabled}
            onSave={() =>
              workAuthorPublisherUpdateStore.saveWorkAuthorPublisher()
            }
            onCancel={() =>
              workAuthorPublisherUpdateStore.cancelWorkAuthorPublisher()
            }
          />
          <ErrorDialog
            open={workAuthorPublisherUpdateStore.errorDialogOpened}
            title={workAuthorPublisherUpdateStore.errorTitle}
            description={workAuthorPublisherUpdateStore.errorDescription}
            onClose={() => workAuthorPublisherUpdateStore.closeErrorDialog()}
          />
          <ConfirmCancelDialog
            open={workAuthorPublisherUpdateStore.confirmDialogOpened}
            title={workAuthorPublisherUpdateStore.confirmDialogTitle}
            description={
              workAuthorPublisherUpdateStore.confirmDialogDescription
            }
            onConfirm={() =>
              workAuthorPublisherUpdateStore.executeConfirmedAction()
            }
            onCancel={() => workAuthorPublisherUpdateStore.closeConfirmDialog()}
          />
        </>
      );
    }
  );
